// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__cplZx","bigColWidth":"Table_bigColWidth__2M72q","biggerColWidth":"Table_biggerColWidth__E97Ob","row":"Table_row__2c_O8","col":"Table_col__ZNqcP"};